__turbopack_context__.v({
  "actions": "fZWheG_actions",
  "button": "fZWheG_button",
  "colorIdWarning": "fZWheG_colorIdWarning",
  "container": "fZWheG_container",
  "content": "fZWheG_content",
  "name": "fZWheG_name",
  "remove": "fZWheG_remove",
});
